<template>
  <div class="search-product" v-if="items.hits.length > 0" id="js-productlist-notification-url" :data-url-add="prestaUrl +'/module/mailalerts/actions?process=add'"
    :class="{'category_list': isCategory}">
    <!-- <div class="count-product-list count-product-list--left" v-if="items.nbHits > 0 && pageNotPrest && querySearch">
      {{countText}}
    </div> -->
    <div class="more-filter-mobile" v-if="isOnly && filters.length > 0" @click="openMobile">
        <svg
            width="20"
            height="15"
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.1693 12.3002C10.254 12.049 10.3 11.78 10.3 11.5002C10.3 11.2204 10.254 10.9514 10.1693 10.7002H18.8C19.2418 10.7002 19.6 11.0584 19.6 11.5002C19.6 11.942 19.2418 12.3002 18.8 12.3002H10.1693ZM5.43074 12.3002H1.3C0.858172 12.3002 0.5 11.942 0.5 11.5002C0.5 11.0584 0.858172 10.7002 1.3 10.7002H5.43074C5.34596 10.9514 5.3 11.2204 5.3 11.5002C5.3 11.78 5.34596 12.049 5.43074 12.3002Z"
            fill="#494D49"
            />
            <circle
            cx="7.80078"
            cy="11.5"
            r="2.5"
            fill="white"
            stroke="#494D49"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            />
            <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.1693 4.3002C15.254 4.04902 15.3 3.77998 15.3 3.5002C15.3 3.22042 15.254 2.95137 15.1693 2.7002H18.3C18.7418 2.7002 19.1 3.05837 19.1 3.5002C19.1 3.94202 18.7418 4.3002 18.3 4.3002H15.1693ZM10.4307 4.3002H0.8C0.358172 4.3002 0 3.94202 0 3.5002C0 3.05837 0.358172 2.7002 0.8 2.7002H10.4307C10.346 2.95137 10.3 3.22042 10.3 3.5002C10.3 3.77998 10.346 4.04902 10.4307 4.3002Z"
            fill="#494D49"
            />
            <circle
            cx="12.8008"
            cy="3.5"
            r="2.5"
            fill="white"
            stroke="#494D49"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            />
        </svg>
        Filtruj
        <span v-if="filterActive > 1">({{filterActive - 1}})</span>
    </div>
    <div class="filter-products" v-if="isOnly"
        :class="{'open-mobile': visibleMobileProp, 'empty-filter': filters.length === 0}">
        <div class="count-product-list"></div>
      <div v-for="(filter, index) in filters" :key="index">
        <filter-item
          v-if="index < filterCount && filter.name !== 'id_category' && !filter.nodisplay"
          :title="filter.name"
          @changeInput="onchangeInput"
          :items="filter.value"
        ></filter-item>
      </div>
      <div
        class="more-filter"
        v-if="filters.length > filterCount"
        @click="filterCount = 100"
      >więcej filtrów</div>
      <div
        class="clear-filters"
        v-if="filterActive > 1"
        @click="clearFilter"
      >
        <img
          src="data:image/jpeg;base64,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
"        />
        Wyczyść filtry
      </div>
    </div>
    <div class="grid_view">
      <search-sorting
        @changeSort="changeSort($event)"
      ></search-sorting>
      <div class="product-item-list" id="product_list" v-if="pageNotPrest">
        <search-product-item v-for="(item,n) in items.hits" :key="item.id" :post="item" :index="n" :favourieList="favouriteList"></search-product-item>
      </div>
    </div>
    <search-pagination
      v-if="isOnly && pageNotPrest"
      typePagination="products"
      :querySearch="querySearch"
      :pagesCount="items.nbPages"
      :filtersProp="filters"
      :pageCurrent="this.items.page"
      @nextPageGo="nextPageGo($event)"
      @prevPageGo="prevPageGo($event)"
      :key="searchPagination"
    ></search-pagination>
  </div>
</template>

<script>
import SearchProductItem from '@/components/Algolia/components/search-products-item'
import SearchPagination from '@/components/Algolia/components/search-pagination.vue'
import SearchSorting from '@/components/Algolia/components/search-sorting.vue'
import FilterItem from '@/components/Algolia/components/filter-item.vue'
import getUrlParameter from '@/shared/geturlparamter'
import odmien from '@/shared/polishends'
import { getWish } from '@/api/wishList'
// import { index } from '@/api/algolia/api'
export default {
  name: 'SearchProduct',
  data: function () {
    return {
      moreProduct: false,
      countItems: 0,
      currentPage: this.items.page,
      refresh: false,
      filters: undefined,
      filterCount: undefined,
      filterActive: 0,
      favouriteList: undefined,
      filterLength: 0,
      filterIndex: 0,
      countText: '',
      // eslint-disable-next-line no-undef
      prestaUrl: baseUri,
      searchPagination: 0,
      // eslint-disable-next-line no-undef
      isCategory: isCategory || null
    }
  },
  props: {
    items: Object,
    multipleList: Object,
    isOnly: Boolean,
    querySearch: String,
    onrefresh: undefined,
    visibleMobileProp: undefined,
    filterVisible: Number,
    pageNotPrest: false
  },
  components: {
    SearchProductItem,
    SearchPagination,
    FilterItem,
    SearchSorting
  },
  created: function () {
    var items = this.items
    this.filterCount = this.filterVisible
    var features = []
    this.searchPagination++

    let multipleList = this.multipleList.results
    let featureConvert = []

    // Tranformacja otrzymanych filtrów z Algolii na Javascriptową tablicę

    Object.keys(items.facets).map(function (key) {
      let name = key
      name = name.substring(name.indexOf('.') + 1)
      let feature = []
      feature['name'] = name
      feature['value'] = []
      Object.keys(items.facets[key]).map(function (key2) {
        let featureValue = []
        featureValue['name'] = key2
        featureValue['value'] = items.facets[key][key2]
        featureValue['selected'] = false
        feature['value'].push(featureValue)
      })
      features.push(feature)
    })

    for (let i = 1; i < multipleList.length; i++) {
      let itemLoop = multipleList[i]
      Object.keys(itemLoop.facets).map(function (key) {
        let name = key
        name = name.substring(name.indexOf('.') + 1)
        featureConvert['name'] = name
        featureConvert['value'] = []
        Object.keys(itemLoop.facets[key]).map(function (key2) {
          let featureValue = []
          featureValue['name'] = key2
          featureValue['value'] = itemLoop.facets[key][key2]
          featureValue['selected'] = false
          featureConvert['value'].push(featureValue)
        })
      })
      features.forEach(item => {
        if (item.name === featureConvert.name) {
          item.value = featureConvert.value
        }
      })
    }
    this.filters = features

    let filtersArray = []
    let filtersString = getUrlParameter('filters')
    let filtersStringItem = filtersString.split('|')
    filtersStringItem.forEach(item => {
      let itemsplit = item.split(':')
      let itemArray = []
      for (let i = 0; i < itemsplit.length; i++) {
        if (i === 0) {
          itemArray['name'] = itemsplit[i]
        } else {
          itemArray['value'] = []
          itemsplit[i].split(',').forEach(value => {
            itemArray['value'].push(value)
          })
        }
      }
      filtersArray.push(itemArray)
    })

    // Zaznaczanie aktywnych filtrów na podstawie adresu url
    this.filterActive = filtersArray.length
    this.filters.forEach(item => {
      filtersArray.forEach(item2 => {
        if (item.name === item2.name) {
          item.value.forEach(value => {
            item2.value.forEach(value2 => {
              if (value.name === value2) {
                value.selected = true
              }
            })
          })
        }
      })
    })
    // Przygotowanie listy zaznaczonych filtrów do połączenia
    let filterstoConnect = []
    filtersArray.forEach(item => {
      let valueprepare = []
      if (item.value !== undefined) {
        item.value.forEach(item2 => {
          valueprepare.push({
            name: item2,
            selected: true
          })
        })
      }
      filterstoConnect.push({
        name: item.name,
        value: valueprepare
      })
    })

    // Połączenie zaznaczonych filtrów aby te których nie ma na liście nie zostały pominięte
    filterstoConnect.forEach(item => {
      this.filters.forEach(item2 => {
        if (item.name === item2.name) {
          item2.value = item2.value.concat(item.value)
        }
      })
    })
    // Usunięcie powtarzajacych się filtrów zostawiając te które są pierwsze w kolejności
    function uniq (a, key) {
      let seen = new Set()
      return a.filter(item => {
        let k = key(item)
        return seen.has(k) ? false : seen.add(k)
      })
    }
    this.filters.forEach(item => {
      item.value = uniq(item.value, it => it.name)
    })

    var features2 = []
    this.filters.forEach((item, index, object) => {
      var count = 0
      var selected = false
      item.value.forEach(item2 => {
        count += item2.value
        if (item2.selected) {
          selected = true
        }
      })
      if (selected) {
        features2.push(item)
      } else if (count > 9) {
        features2.push(item)
      }
    })
    this.filters = features2
    // Sortowanie filtrów (pierwsze filtry aktywne)
    let filterMoreCount = 0
    this.filters.forEach((item) => {
      let countSelected = 0
      item.value.forEach((value) => {
        if (value.selected) {
          countSelected++
        }
      })
      if (countSelected > 0) {
        filterMoreCount++
      }
      item.selectedCount = countSelected
    })
    if (filterMoreCount > this.filterCount) {
      this.filterCount = filterMoreCount
    }

    this.filters.sort((a, b) => b.selectedCount - a.selectedCount)

    this.filters.forEach((item) => {
      item.value.sort((a, b) => b.selected - a.selected)
    })

    // Ukrywanie filtru który posiada jeden element pasujący do wszystkich produktów

    // this.filters.forEach((item, index, object) => {
    //   if (item.value.length === 1) {
    //     if (item.value[0].value === this.items.nbHits) {
    //       this.filters.splice(index, 1)
    //     }
    //   }
    //   if (item.name === 'id_category') {
    //     this.filters.splice(index, 1)
    //   }
    // })
    this.filters = this.filters.filter((item) => {
      if (item.name !== 'id_category') {
        return item
      }
    })
    this.filters = this.filters.filter((item) => {
      if (item.value[0].value !== this.items.nbHits) {
        return item
      }
      if (item.selectedCount > 0) {
        return item
      }
    })
    // Uruchamianie Lazy Load
    setTimeout(() => {
      // eslint-disable-next-line
      var lazy_load = new LazyLoad({
        elements_selector: '.lazyload',
        callback_error: (el) => {
          // eslint-disable-next-line
          el.setAttribute('src', baseUri + 'public/assets/FFF.png')
        }
      })
      lazy_load.update()
    }, 10)
    getWish()
      .then(data => {
        localStorage.favouriteList = JSON.stringify(data)
      })

    this.countFilter()

    // Count product display
    setTimeout(() => {
      let countProduct = document.getElementsByClassName('count-product-list')
      if (countProduct.length > 0) {
        for (let item of countProduct) {
          this.countText = '<strong>' + this.items.nbHits + '</strong> ' + odmien(this.items.nbHits, 'produkt', 'produkty', 'produktów')
          item.innerHTML = this.countText
        }
      }
    })
    setTimeout(() => {
      if (document.querySelector('.sort-select') !== null) {
        if (!this.visibleMobileProp) {
          document.querySelector('.sort-select').classList.remove('open')
        } else {
          document.querySelector('.sort-select').classList.add('open')
        }
      }
    })
  },
  methods: {
    nextPageGo (number) {
      this.currentPage = number
      this.$emit('currentPageGo', number)
    },
    prevPageGo (number) {
      this.currentPage = number
      this.$emit('currentPageGo', number)
    },
    changeSort (name) {
      this.countFilter()
      this.$emit('changeSort', name)
    },
    onchangeInput () {
      this.countFilter()
      this.$emit('changedFilter', this.filters)
    },
    clearFilter () {
      this.countFilter()
      this.filters.forEach(item => {
        item.value.forEach(value => {
          value.selected = false
        })
      })
      this.$emit('changedFilter', this.filters)
    },
    onRefresh () {
      this.refresh = !this.refresh
    },
    openMobile () {
      this.visibleMobileProp = !this.visibleMobileProp
      this.filterCount = 100
      if (document.querySelector('.sort-select') !== null) {
        if (!this.visibleMobileProp) {
          document.querySelector('.sort-select').classList.remove('open')
        } else {
          document.querySelector('.sort-select').classList.add('open')
        }
      }
    },
    countFilter () {
      let filtersCount = 0
      this.filters.forEach(item => {
        let count = 0
        item.forEach(item2 => {
          count += item.value
        })
        if (count >= 10) {
          filtersCount++
        } else {
          return false
        }
      })
      this.filterLength = filtersCount
    },
    viewfilter (filter) {
      let count = 0
      let selected = false
      filter.value.forEach((item) => {
        count += item.value
        if (item.selected) {
          selected = true
        }
      })
      if (count >= 10 || selected) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-product {
  position: relative;
  margin-bottom: 20px;
  min-height: 40px;
  @media all and (max-width: 767px) {
    min-height: 40px;
  }
  @media all and (max-width: 767px) {
    .grid_view {
      .sort {
        position: absolute;
        top: -2px;
        left: 0;
        display: block;
      }
    }
  }
}

.search {
  @media all and (min-width: 1024px) {
    .grid_view {
      .sort {
        position: absolute;
        top: 6px;
      }
    }
  }
  @media all and (max-width: 767px) {
    .grid_view {
      .sort {
        position: absolute;
        top: 0px;
        left: 0;
      }
    }
  }
}

.category_list {
  .nbresult {
    display: none;
  }
  .product-item-list {
    .pro_first_box,
    .product-item {
      width: 25%;
      // margin-bottom: 5px;
      // margin-top: 20px;
      position: relative;
      @media all and (max-width: 992px) {
        width: 33.333%;
      }
      @media all and (max-width: 640px) {
        width: 50%;
      }
      // &::after {
      //   content: "";
      //   position: absolute;
      //   top: -20px;
      //   left: 0;
      //   right: 0;
      //   border-top: 1px solid #e5e5e5;
      // }
    }
  }
}
.new-products,
.prices-drop,
.manufacturer {
  .product-item-list {
    .pro_first_box,
    .product-item {
      width: 25%;
      // margin-bottom: 5px;
      // margin-top: 20px;
      position: relative;
      @media all and (max-width: 992px) {
        width: 33.333%;
      }
      @media all and (max-width: 640px) {
        width: 50%;
      }
      // &::after {
      //   content: "";
      //   position: absolute;
      //   top: -20px;
      //   left: 0;
      //   right: 0;
      //   border-top: 1px solid #e5e5e5;
      // }
    }
  }
}
.product-item-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  .pro_first_box,
  .product-item {
    width: 25% !important;
    // margin-bottom: 5px;
    // margin-top: 20px;
    position: relative;
    @media all and (max-width: 1320px) {
      width: 33.333% !important;
    }
    @media all and (max-width: 640px) {
      width: 50% !important;
    }
    // &::after {
    //   content: "";
    //   position: absolute;
    //   top: -20px;
    //   left: 0;
    //   right: 0;
    //   border-top: 1px solid #e5e5e5;
    // }
  }
}
.clear-filters {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 5px 0;
  font-size: 14px;
  img {
    width: 20px;
    display: inline-block;
    vertical-align: middle;
    margin:0 5px -1px 0;
  }
}
.filter-products {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
  min-height: 39px;
  @media all and (min-width: 1024px) {
    padding-right: 170px;
  }
  @media all and (max-width: 767px) {
      display: none;
      .count-product-list {
        display: none;
      }
      &.open-mobile {
          display: flex;
          margin-top: 44px;
      }
  }
  &.empty-filter {
    @media all and (max-width: 767px) {
      display: block;
    }
  }
  &__title {
    margin-right: 13px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  &__item {
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
.more-filter {
  color: inherit;
  cursor: pointer;
  margin-right: 15px;
  font-size: 14px;
  text-decoration: underline;
}
.more-filter-mobile {
  color: #FFF;
  background: #8ab82d;
  font-size: 14px;
  font-weight: normal;
  text-transform: uppercase;
  cursor: pointer;
  width: 49%;
  margin-left: auto;
  margin-bottom: 20px;
  border-radius: 50px;
  padding: 10px 0;
  display: none;
  @media all and (max-width: 767px) {
      display: block;
      text-align: center;
      transform: translateY(3px);
      svg {
        margin: 1px 3px -1px 0;
      }
      svg * {
        fill: #FFF;
        stroke: #FFF;
      }
  }
}
.sort {
  display: flex;
  justify-content: flex-end;
  .sort-select {
    margin: 0 0 0 5px;
    min-width: 130px;
    position: relative;
    &__current {
      min-width: 40px;
      position: relative;
      border: 1px solid #A1A1A1;
      border-radius: 4px;
      line-height: 23px;
      height: 23px;
      text-decoration: none;
      text-align: left;
      outline: 0;
      vertical-align: middle;
      background: #fff;
      display: inline-block;
      cursor: default;
      width: 100%;
      padding: 0 6px;
      cursor: pointer;
    }
    &__list {
      position: absolute;
      z-index: 200;
      min-width: 100%;
      max-height: 200px;
      min-height: 1em;
      border: solid 1px #cecece;
      background: #ffffff;
      box-shadow: 0 2px 6px rgba(0,0,0,.2);
      overflow: auto;
      border-radius: 0 0 4px 4px;
      li {
        list-style: none;
        display: block;
        padding: 0;
        margin: 0;
        line-height: 2em;
        padding: 0 .5em;
        white-space: nowrap;
        overflow: hidden;
        background: 6px center no-repeat;
        cursor: pointer;
        &:hover {
          background: #f0f0f0;
          color: #8AB82D;
        }
      }
    }
  }
}
</style>

<style lang="scss">
// .lazyload.lazy-picture-fallback,
// .lazyload.error,
// .lazyload.loading {
//   padding-bottom: 100%;
//   height: 0;
// }
.read-more {
  display: block;
  margin: 20px auto 50px auto;
  max-width: 230px;
  padding: 0 10px;
  min-width: 40px;
  height: 40px;
  line-height: 42px;
  background-color: #8ab82d;
  text-align: center;
  text-transform: uppercase;
  font-size: 13px;
  color: #fff;
  -webkit-transition: all 0.15s ease;
  -o-transition: all 0.15s ease;
  transition: all 0.15s ease;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    background: #7dab20;
  }
  &--posts {
    margin-bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Algolia/components/search-products.vue